import React from 'react';

import Typography from '@material-ui/core/Typography';
import Bold from '../Bold';
import MarkingItem from '../MarkingItem';
import Topic from '../Topic';

import { useStyles } from './styles';

function ModalWithTermsOfService() {
  const classes = useStyles();

  return (
    <div style={{ paddingHorizontal: 15, paddingTop: 15 }}>
      <div style={{ flex: 2 }}>
        <Typography className={classes.textStyle}>TERMOS DE USO</Typography>
      </div>
      <br />
      <div style={{ flex: 1 }} />
      <Typography className={classes.text}>
        Ao acessar ou utilizar quaisquer dos serviços disponibilizados pela XMEI
        BRASIL SERVIÇOS S.A., sociedade anônima de capital fechado, inscrita no
        CNPJ sob o nº 32.765.502/0001-08, com sede na Avenida Copacabana, nº
        297, Quadra 145, Lote Area 3, Goiânia – Goiás, CEP 74.343-240, doravante
        denominado ("
        <Bold text="XMEI" />
        ") por meio do site e/ou do aplicativo XMEI ("
        <Bold text="Software" />
        "), utilizando-se de qualquer meio de acesso, incluindo aparelhos
        móveis, celulares, tablets, computadores pessoais, navegadores de
        internet e demais meios de acesso que vierem a ser desenvolvidos, você
        (“
        <Bold text="Usuário" />
        ”), na qualidade de pessoa física ou jurídica, leu, entendeu, concorda e
        aceita (e tem a capacidade jurídica para tanto) as presentes cláusulas e
        condições, vinculando-se e obrigando-se ao presente termo de uso (“
        <Bold text="Termo de Uso" />
        ”) e principalmente consentindo com o acesso, coleta, uso,
        armazenamento, tratamento e técnicas de proteção às informações do
        Usuário para a integral execução das funcionalidades ofertadas pela
        XMEI.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        A intenção da XMEI é prestar um serviço de assessoria fiscal de
        qualidade de forma prática e que facilite o seu dia a dia e da sua
        empresa ("
        <Bold text="Serviços" />
        "), os serviços da XMEI não compreende serviços contábeis. A XMEI está
        aberta às opiniões de seus Usuários e quer ajudar o Usuário a crescer de
        maneira organizada. Para, tal, a XMEI apresenta as condições de
        utilização do serviços que disponibiliza, conforme este Termo de Uso.
      </Typography>
      <br />
      <Topic text="1. Termos Gerais" />
      <Typography className={classes.text}>
        O presente Termo de Uso entra em vigor na data de seu aceite e vigorará
        por prazo indeterminado.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        Considerando que a internet é um sistema mutável e está em constante
        evolução, sendo essencial que as empresas que atuam por meio dela também
        mantenham-se atualizadas, de forma a buscar a melhor comunicação
        possível com seus usuários, a XMEI se reserva o direito de, a qualquer
        tempo e a sua exclusiva discricionariedade, bem como em eventual
        atualização normativa, aditar o presente Termo de Uso e sua Política de
        Privacidade (“
        <Bold text="Termos Atualizados" />
        ”) disponíveis.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        O Usuário, desde já aceita que os Termos Atualizados serão
        disponibilizados por meio do Software (APP) e/ou Site da XMEI,
        compromete-se a lê-los integralmente e, caso não concorde com os Termos
        Atualizados, sugerimos que deixe de utilizar nosso Serviço
        imediatamente.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        A XMEI ainda se reserva o direito de fazer alterações no Software (APP),
        bem com em seus Serviços, visando sempre a melhoria dos serviços
        prestados aos Usuários.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        Em respeito à legislação vigente e para garantir controle e segurança
        dos Serviços, a XMEI se reserva o: (i) direito de definir critérios de
        acesso e elegibilidade aos Serviços à qualquer pessoa, a seu exclusivo
        critério; (ii) direito de bloquear, editar, remover ou monitorar o
        acesso do Usuário, conteúdos e/ou contas, que estejam desrespeitando o
        presente Termo de Uso e/ou a Política de Privacidade e/ou qualquer
        legislação vigente aplicável.
      </Typography>
      <Typography>
        Caso a XMEI ou o Usuário resolva cancelar o acesso aos Serviços, todo o
        conteúdo, incluindo, mas não se limitando a informações fiscais,
        documentos, títulos, notas, pagamentos, enfim, toda informação
        compartilhada ou inserida pelo Usuário no/por meio dos Serviços ("
        <Bold text="Conteúdo" />
        "), será disponibilizado pelo período de 30 (trinta) dias, contados do
        cancelamento do acesso. Após este período, o Conteúdo deixará de ser
        acessível pela conta ao Usuário. A XMEI reserva o direito de modificar
        seus Serviços, ressalvado o acima disposto, sem a necessidade de envio
        de aviso prévio ao Usuário e a qualquer tempo, à discricionariedade
        exclusiva da XMEI, não cabendo qualquer responsabilidade à XMEI nesse
        sentido.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        Caso o serviço venha a ser cancelado pela XMEI, o Usuário receberá
        comunicação por e-mail com antecedência de 30 (trinta) dias. A XMEI
        também enviará ao Usuário o termo de transferência de técnica, se
        cabível.
      </Typography>
      <Typography>
        A XMEI ainda poderá bloquear o acesso ao Software ao Usuário e cessar a
        prestação de Serviço ao Usuário que esteja desrespeitando as regras de
        conteúdo aqui estabelecidas ou as normas legais em vigor, a qualquer
        tempo e sem a necessidade de prévio aviso ao Usuário, situação em que o
        Conteúdo também será bloqueado.
      </Typography>
      <br />

      <Topic text="2. Licença de Uso do Software" />

      <Typography className={classes.text}>
        Este Termo de Uso concede ao Usuário uma licença revogável, não
        exclusiva e intransferível para usar o Software desenvolvido pela XMEI.
        O Usuário não poderá utilizar e nem permitir o uso do Software para
        outra finalidade que não seja o uso próprio. Em nenhuma hipótese o
        Usuário terá acesso ao código fonte do Software (APP) ora licenciado,
        por este se tratar de propriedade intelectual da XMEI.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        Sendo assim, fica proibido ao Usuário:
      </Typography>
      <MarkingItem
        marking="a)"
        text="copiar, ceder, sublicenciar, vender, dar em locação ou em garantia, reproduzir, doar, alienar de qualquer forma, transferir total ou parcialmente, sob quaisquer modalidades, gratuita ou onerosamente, provisória ou permanentemente, o Software objeto deste Termo de Uso, assim como seus módulos, partes, manuais e/ou quaisquer informações relativas ao Software;"
      />
      <MarkingItem
        marking="b)"
        text="praticar engenharia reversa, descompilação e/ou desmontagem do Software;"
      />
      <MarkingItem
        marking="c)"
        text="qualquer uso dos Serviços ou seu acesso por meios automatizados ou macros (crawling, scraping, caching), incluindo, mas não se limitando, ao acesso ou visualização ou obtenção de informação dos Serviços, do Conteúdo, documentos e informações dos demais usuários dos Serviços ou terceiros afiliados à XMEI e aos Serviços, com exceção dos mecanismos de busca padrão ou demais tecnologias aprovadas pela XMEI."
      />
      <br />

      <Topic text="3. Deveres, obrigações, declarações e garantias do Usuário" />
      <Typography className={classes.text}>Obriga-se o Usuário a:</Typography>
      <MarkingItem
        marking="a)"
        text="Manter-se treinado ou manter pessoal treinado para a operação do Software (APP) e para a comunicação com a XMEI e prover, sempre que ocorrerem quaisquer problemas com o Software, toda a documentação, relatórios e demais informações que relatem as circunstâncias em que os problemas ocorreram, objetivando facilitar e agilizar os trabalhos e as soluções para o caso;"
      />
      <MarkingItem
        marking="b)"
        text="Manter, às suas expensas, linha de telecomunicação, celular ou fixa, aparelho de celular, software de comunicação, endereço de correio eletrônico e outros recursos necessários à comunicação com a XMEI;"
      />
      <MarkingItem
        marking="c)"
        text="Responsabilizar-se pelas informações inseridas no Software, pelo cadastramento, permissões, senhas e modo de utilização de seus usuários. A XMEI em hipótese alguma será responsável pelo Conteúdo inserido no Software, não sendo, portanto, estas informações revisadas em momento algum. A responsabilidade pelas informações inseridas no Software é exclusivo do Usuário;"
      />
      <MarkingItem
        marking="d)"
        text="Certificar-se de que não está proibido por determinação legal e/ou contratual de passar informações financeiras, de conta, pessoais, bem como quaisquer outros dados à XMEI, necessários para a execução do serviço oferecido por este Termo de Uso;"
      />
      <MarkingItem
        marking="e)"
        text="Não utilizar o Software de qualquer forma que possa implicar em ilícito, infração, violação de direitos e/ou danos à XMEI ou terceiros;"
      />
      <MarkingItem
        marking="f)"
        text="Não publicar, enviar ou transmitir qualquer arquivo que contenha vírus, worms, cavalos de tróia ou qualquer outro programa que possa contaminar, destruir ou interferir no pleno funcionamento do Software;"
      />
      <MarkingItem
        marking="g)"
        text="Informar à XMEI sempre que houver qualquer alteração do Conteúdo que possa impedir, limitar e/ou prejudicar o acesso ao Conteúdo necessário para a execução das funcionalidades ofertadas pelo Software (APP);"
      />
      <MarkingItem
        marking="h)"
        text="Caso o Usuário acredite que seu login e senha de acesso aos Serviços tenham sido apropriados por outrem e/ou sejam de conhecimento de outras pessoas, por qualquer razão, deverá imediatamente comunicar por escrito à XMEI, através do e-mail contato@xmeibrasil.com.br, sem prejuízo da alteração de senha imediata por meio do Software (APP)."
      />
      <Typography>
        O Usuário concorda e tem ciência que é o responsável exclusivo por todos
        os custos e despesas referentes ao seu acesso e uso dos Serviços,
        incluindo mas não se limitando a mensagens, conexão de internet e demais
        custos incorridos em conexão ao uso dos Serviços.
      </Typography>
      <br />

      <Topic text="4. Deveres, obrigações, declarações e garantias da XMEI" />
      <Typography className={classes.text}>Obriga-se a XMEI a:</Typography>
      <MarkingItem
        marking="a)"
        text="Fornecer, ato contínuo ao aceite deste Termo de Uso, acesso ao Software (APP) pelo prazo estabelecido entre as Partes;"
      />
      <MarkingItem
        marking="b)"
        text="Alterar as especificações e/ou características do Software licenciados para a melhoria e/ou correções de erros;"
      />
      <MarkingItem
        marking="c)"
        text="Disponibilizar acesso aos serviços de suporte através de correio eletrônico (contato@xmeibrasil.com.br), para esclarecimento de dúvidas de ordem não funcional diretamente relacionadas a problemas no Software (APP);"
      />
      <MarkingItem
        marking="d)"
        text="Envidar melhores esforços para manter as informações financeiras, de conta e pessoais do Usuário, bem como registros de acesso, em sigilo, nos termos deste Termo de Uso à exceção por determinação legal conforme as Leis da República Federativa do Brasil."
      />
      <br />

      <Topic text="5. Envio de informações" />
      <Typography className={classes.text}>
        Quando o Usuário utiliza os Serviços da XMEI, envia diversos documentos,
        dados e mensagens.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        O Usuário tem ciência e concorda que a XMEI e seus Serviços não
        funcionam como backup do Conteúdo e/ou de armazenamento de dados e
        informações do Usuário.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        Consequentemente, para garantir a contínua segurança de seus dados e
        conteúdo, o Usuário responsabiliza-se em manter sua própria cópia de
        segurança (backup) bem como armazenamento dos documentos físicos,
        isentando a XMEI de qualquer responsabilidade nesse sentido. A XMEI não
        será responsável por qualquer modificação, suspensão ou descontinuação
        dos Serviços, ou qualquer perda, ainda que parcial, do Conteúdo e
        informações do Usuário.
      </Typography>
      <br />

      <Topic text="6. Da Remuneração e Forma de Pagamento" />

      <Typography className={classes.text}>
        Assim que o Usuário fizer seu cadastro na XMEI você perceberá que nosso
        Serviço é cobrado por tipo de empresa (MEI, SIMPLES e LUCRO PRESUMIDO).
      </Typography>
      <Typography className={classes.textMarginTop10}>
        O serviço básico da XMEI engloba um sistema de gestão financeira, com
        vendas, receitas, despesas, sistemas de DAS para MEIs bem como sistema
        de mensagens e alertas sobre eventos importantes, emissão de notas
        fiscais, declaração de faturamento e monitoramento de CND.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        Pode ser que durante o uso dos Serviços da XMEI a empresa do Usuário
        cresça e precise de mais funcionalidades. Se isso acontecer e o Usuário
        precisar de outras funcionalidades que ainda não contratou, poderá mudar
        o plano e, nesse caso, a XMEI irá cobrar o valor correspondente ao plano
        escolhido após o Usuário escolher e aceitar o plano substituto. Neste
        caso, o Usuário poderá recorrer à XMEI como escritório de assessoria
        fiscal, que possui funcionalidade adicionais à Conta Básica.
      </Typography>
      <br />

      <Topic text="7. Publicidade" />
      <Typography>
        A XMEI poderá divulgar anúncios de diversos anunciantes, logo, links,
        endereços virtuais ou demais caminhos que direcionem o Usuário para
        sites/serviços/aplicativos/softwares de terceiros que poderão ser
        disponibilizados por meio do Software (APP). A XMEI não atua como
        prestador de serviços de consultoria ou ainda intermediário ou
        participante em nenhum negócio jurídico entre seus Usuários e seus
        anunciantes. Sendo assim, o Software pode incluir ou direcionar o
        Usuário a conteúdo, ambientes virtuais, informações ou dados que não são
        de seu controle ou responsabilidade. Ainda, a inclusão desses links não
        implica no endosso ou anuência da XMEI, portanto, a XMEI não se
        responsabiliza ou garante, a qualquer título e a qualquer tempo, por
        referidos serviços/ambientes virtuais/softwares/sites/aplicativos de
        terceiros ou por eles disponibilizados, sendo a responsabilidade de seu
        respectivo controlador.
      </Typography>
      <Typography>
        É dever do Usuário a leitura dos Termos de Uso e Política de Privacidade
        do site acessado e agir conforme o determinado. A XMEI não verifica,
        controla, aprova ou garante a adequação ou exatidão das informações ou
        dados disponibilizados em tais links, não sendo, portanto, responsável
        por prejuízos, perdas ou danos ocasionados por atrasos, defeitos, erros
        ou omissões que possam existir nos sistemas ou serviços disponibilizados
        pelos sites referidos acima ou ocorridos pela visita de tais sites,
        cabendo ao Usuário verificar a confiabilidade das informações e dados
        ali exibidas antes de utilizá-los.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        Desse modo, o Usuário deve sempre verificar a veracidade das informações
        obtidas pelo meio eletrônico da XMEI e tomar todas as medidas
        necessárias para se proteger de danos, fraudes ou estelionatos,
        inclusive online e off-line.
      </Typography>
      <br />

      <Topic text="8. Indisponibilidade do serviço" />
      <Typography className={classes.text}>
        Apesar de todos os esforços da XMEI para manter os Serviços em pleno
        funcionamento, o Usuário tem conhecimento e concorda que a internet (e,
        por consequência os Serviços) está continuamente exposta a terceiros,
        usuários ou não, hackers¸ softwares mal intencionados e similares,
        estando o serviço sujeito a diversas brechas de segurança e que,
        portanto, o compartilhamento e inserção de informações e Conteúdo pelo
        Usuário nos Serviços ou por meio dos Serviços podem não ser totalmente
        seguros, o Usuário assume o risco de utilização e acesso dos/aos
        Serviços, isentando a XMEI de qualquer responsabilidade nesse sentido.
      </Typography>
      <Typography>
        Ainda que seja a intenção da XMEI que o Serviço esteja disponível o
        máximo de tempo possível, a XMEI reconhece que, por questões técnicas e
        operacionais, terão ocasiões em que o Serviço será interrompido,
        incluindo, mas não se limitando, a interrupções para reparos,
        atualizações, por motivos de falha na telecomunicação, falta de energia
        ou de equipamentos, não cabendo qualquer responsabilidade da XMEI nesse
        sentido. No caso de interrupções programadas, a XMEI notificará via
        e-mail seus Usuários sobre a interrupção e seu provável tempo de
        duração.
      </Typography>
      <br />

      <Topic text="9. Das Garantias Limitadas" />
      <Typography className={classes.text}>
        Na extensão máxima permitida pela lei em vigor, o Software é fornecido
        "no estado em que se encontra" e "conforme a disponibilidade", com todas
        as falhas e sem garantia de qualquer espécie.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        A XMEI não garante que as funções contidas no Software (APP) atendam a
        todas as suas necessidades, que a operação do Software será ininterrupta
        e/ou livre de erros, que qualquer serviço continuará disponível, que os
        defeitos no Software serão corrigidos ou que o Software será compatível
        ou funcione com qualquer software, aplicações ou serviços de terceiros.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        A XMEI utilizará seus melhores esforços para corrigir eventuais falhas e
        erros no funcionamento do Software, podendo à seu critério, substituir a
        cópia dos programas com falhas por cópias corrigidas. Contudo a XMEI não
        pode garantir um prazo para tais reparos. Os erros no funcionamento
        serão corrigidos durante o período que for necessário e a XMEI não se
        responsabiliza por danos decorrentes da não disponibilidade.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        Em nenhum caso a XMEI será responsável por danos pessoais e/ou qualquer
        prejuízo incidental, especial, indireto ou consequente, incluindo, sem
        limitação, prejuízos por perda de lucro, corrupção ou perda de dados,
        falha de transmissão e/ou recepção de dados, não continuidade do negócio
        ou qualquer outro prejuízo e/ou perda comercial, decorrentes ou
        relacionados à perda de informações ou inabilidade em usar o Software,
        por qualquer outro motivo.
      </Typography>
      <Typography>
        A XMEI tampouco se responsabiliza por qualquer dano, prejuízo e/ou perda
        no equipamento do usuários causados por falhas no sistema, no servidor
        ou na conexão à Internet, ainda que decorrentes de condutas de
        terceiros, inclusive por ações de Softwares maliciosos como vírus,
        cavalos de tróia, e outros que possam, de algum modo, danificar o
        equipamento ou a conexão dos Usuários em decorrência do acesso,
        utilização e/ou navegação da XMEI, bem como a transferência de dados,
        arquivos, imagens, textos, áudios e/ou vídeos contidos no mesmo.
      </Typography>
      <Typography>
        O Usuário reconhece e concorda que, para que grande parte de seus
        Serviços sejam oferecidos gratuitamente, a XMEI considerou os riscos
        envolvidos e a avaliação de viabilidade econômica dos Serviços. Por esse
        motivo, o Usuário declara, reconhece e concorda, expressamente, que o
        valor máximo de indenização devido pela XMEI e suas partes relacionadas,
        em decorrência de sua responsabilidade, decorrentes deste Termo de Uso,
        estará limitado ao valor de 1 (UM) honorário.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        Sob nenhuma circunstância a responsabilidade integral da XMEI com
        relação ao Usuário por todos os danos excederá o valor acima estipulado.
        Esclarece-se que esta cláusula é aplicável caso sejam por qualquer
        motivo reconhecidas pela justiça como inaplicáveis quaisquer
        outras cláusulas deste Termo de Uso.
      </Typography>
      <br />

      <Topic text="10. Isenção de Responsabilidade da XMEI" />
      <Typography className={classes.text}>
        Infelizmente, existem alguns fatores que não podem ser controlados ou
        evitados pela XMEI, e que podem resultar em uma aparente falha em nossos
        Serviços. Sendo assim, não podemos nos responsabilizar por:
      </Typography>
      <MarkingItem
        marking="a)"
        text="falha de operação, operação por pessoas não autorizadas ou qualquer outra causa em que não exista culpa da XMEI;"
      />
      <MarkingItem
        marking="b)"
        text="cumprimento dos prazos legais do Usuário para a entrega de documentos fiscais ou pagamentos de impostos;"
      />
      <MarkingItem
        marking="c)"
        text="danos ou prejuízos decorrentes de decisões administrativas, gerenciais ou comerciais tomadas com base nas informações fornecidas pelo Software;"
      />
      <MarkingItem
        marking="d)"
        text="problemas definidos como “caso fortuito” ou “força maior” contemplados pelo art. 393, do Código Civil Brasileiro;"
      />
      <MarkingItem
        marking="e)"
        text="eventuais problemas oriundos de ações de terceiros que possam interferir na qualidade dos Serviços;"
      />
      <MarkingItem
        marking="f)"
        text="revisar as informações de conta, tampouco pelo Conteúdo fornecidos pelo Usuário ou pelas informações financeiras obtidas junto aos sites e/ou meios virtuais das instituições financeiras, seja no que tange à precisão dos dados, seja quanto à legalidade ou ameaça de violação em função do fornecimento destas informações. O acesso às informações de conta e às informações financeiras do Usuário depende de serviços prestados pelas instituições financeiras. Sendo assim, a XMEI não assume qualquer responsabilidade quanto à qualidade, precisão, pontualidade, entrega ou falha na obtenção das referidas informações junto aos sites e/ou meios virtuais das instituições financeiras;"
      />
      <MarkingItem
        marking="g)"
        text="quaisquer produtos e/ou serviços oferecidos por meio dos sites e/ou meios virtuais das instituições financeiras, ainda que de maneira solidária ou subsidiária, e"
      />
      <MarkingItem
        marking="h)"
        text="falta de envio de informações, informações incompletas ou equivocadas do Usuário e de sua contabilidade que possa prejudicar a correta execução dos Serviços."
      />
      <br />

      <Topic text="11. Consentimento livre, expresso e informado para acesso à informações confidenciais e dados pessoais" />
      <Typography className={classes.text}>
        Para que a XMEI possa ajudar a a empresa do Usuário e prestar seu
        Serviço de forma satisfatória, é necessária uma relação de confiança.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        O Usuário ao aceitar utilizar o Software, além de aceitar integralmente
        este Termo de Uso, também consente, livre e expressamente, que a XMEI
        colete, use, armazene e faça o tratamento de suas informações, incluindo
        seus dados pessoais, financeiros, bancários, de conta, os quais serão
        necessários para que os Serviços ofertados sejam prestados em sua
        integralidade.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        Para tanto, o Usuário consente, livre e expressamente, em fornecer os
        dados que permitam o acesso a suas informações para que o Software
        execute todas as funções para as quais foi projetado.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        Ainda, o Usuário declara e reconhece que, para a prestação dos Serviços
        e funcionalidades ofertadas pelo Software, a XMEI acessa informações
        financeiras diretamente no site e/ou outros meios virtuais das
        instituições financeiras, sem fazer qualquer emulação de medidas de
        segurança, utilizando-se apenas das informações pessoais, de conta, bem
        como outras eventualmente necessárias, fornecidas pelo Usuário, conforme
        autorizado.
      </Typography>
      <Typography>
        A XMEI declara que todas as informações de conta serão utilizadas única
        e exclusivamente para a visualização das Informações Financeiras nos
        sites e/ou meios virtuais das instituições financeiras, sendo
        absolutamente vedado a XMEI a realização de quaisquer transações.
      </Typography>
      <Typography>
        O Usuário consente que quando acessar o site da XMEI, esta poderá
        coletar informações técnicas de navegação, tais como tipo de navegador
        do computador utilizado para acesso ao Site, endereço de protocolo de
        Internet, páginas visitadas e tempo médio gasto no Site. Tais
        informações poderão ser usadas para orientar o próprio Usuário e
        melhorar os Serviços ofertados.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        O Usuário consente livre e expressamente que suas informações poderão
        ser transferidas a terceiros em decorrência da venda, aquisição, fusão,
        reorganização societária ou qualquer outra mudança no controle da XMEI.
      </Typography>
      <br />

      <Topic text="12. Da Propriedade Intelectual" />

      <Typography>
        A XMEI é proprietária ou possui a devida licença de todos os direitos,
        titularidade e participação pertinentes aos Serviços, inclusive todos os
        direitos referentes à propriedade intelectual e todo e qualquer direito
        de propriedade, inclusive todos os requerimentos, renovações, extensões
        e restaurações relacionadas aos Serviços, especialmente incluindo, mas
        não se limitando a, nomes comerciais, marcas comerciais, marcas de
        serviço, insígnias, conjunto imagem (trade dress), nomes de
        domínio, slogans, layout, logotipos, símbolos e outros sinais
        distintivos e elementos de identificação visual, direitos autorais,
        software, patentes de invenção, modelos de utilidade, desenhos
        industriais, know-how e segredos comerciais, quer estejam tais direitos
        registrados ou não, utilizados para prestar os Serviços aos Usuários,
        observada a legislação aplicável referente aos direitos de propriedade
        intelectual e industrial (“
        <Bold text="Propriedade Intelectual" />
        ”).
      </Typography>
      <Typography>
        O Usuário não pode modificar, adaptar, traduzir, preparar trabalhos
        derivados, descompilar, fazer engenharia reversa, desmontar nem tentar
        de forma alguma alterar o código-fonte e/ou Software da XMEI utilizado
        na prestação dos Serviços.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        A reprodução, transmissão e distribuição de tais materiais, não são
        permitidas sem o expresso consentimento por escrito da XMEI, sobretudo
        para o fim econômico ou comercial.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        Será caracterizada como infração da legislação vigente, o uso indevido
        de materiais protegidos por Propriedade Intelectual apresentados na
        XMEI, sujeitando-se o Usuário infrator às medidas judiciais cabíveis à
        espécie, sem prejuízo de eventual indenização por perdas e danos e
        honorários advocatícios à XMEI, bem como a terceiros que venham a sofrer
        pelos atos do Usuário.
      </Typography>
      <br />

      <Topic text="13. Declaração de Vontade" />

      <Typography className={classes.text}>
        O Usuário declara ter ciência dos direitos e obrigações decorrentes do
        presente Termo de Uso, constituindo este instrumento o acordo completo
        entre as partes. Declara, ainda, ter lido, compreendido e aceito todos
        os termos e condições.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        O Usuário declara que foi devidamente informado sobre a Política de
        Privacidade e ambientes de proteção de informações confidenciais, dados
        pessoais e registros de acesso, consentindo livre e expressamente às
        ações de coleta, uso, armazenamento e tratamento das referidas
        informações e dados.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        O Usuário declara ainda que está ciente de que para que usufrua de
        algumas das funcionalidades do Software terá que disponibilizar
        informações de conta para que o Software, de forma automatizada, colete
        informações diretamente nos sites e/ou outros meios virtuais das
        instituições financeiras, sendo a XMEI, neste caso, representante e
        mandatária do Usuário nestes atos.
      </Typography>
      <br />

      <Topic text="14. Da Rescisão" />

      <Typography className={classes.text}>
        O Usuário poderá rescindir o presente contrato a qualquer tempo, desde
        que comunique à XMEI, por escrito, importando, no que se refere ao plano
        contratado, no pagamento pelo mesmo do saldo devedor, se existente.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        No caso de rescisão do presente contrato, os dados pessoais, bancários,
        financeiros e demais informações do Usuário ficarão disponíveis conforme
        este Termo de Uso, podendo ser excluídos permanentemente após 30
        (trinta) dias da data da rescisão.
      </Typography>
      <br />

      <Topic text="15. Das disposições legais finais" />

      <Typography className={classes.text}>
        O Usuário não poderá prestar serviços a terceiros utilizando o Software
        da XMEI sem autorização prévia e expressa da mesma.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        Caso o Usuário venha a desenvolver um novo módulo ou produto que
        caracterize cópia, de todo ou em parte, quer seja do dicionário de
        dados, quer seja do programa, será considerado como parte do Software
        fornecido pela XMEI, ficando, portanto, sua propriedade incorporada pela
        XMEI e seu uso condicionado a estas cláusulas contratuais.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        A tolerância, por qualquer das Partes, à infração das cláusulas e
        disposições contidas neste Termo de Uso e/ou Política de Privacidade,
        bem como a prática de quaisquer atos ou procedimentos não previstos de
        forma expressa, será considerada mera liberalidade, não configurando
        precedente ou novação contratual.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        A XMEI poderá, por meio de comunicação no e-mail indicado pelo Usuário
        em seu cadastro, ou por meio de aviso no Software definir preços para
        oferecimento de determinados conteúdos e/ou serviços, ainda que
        inicialmente tenham sido ofertados de forma gratuita, ou alteração dos
        preços, sendo a utilização dos Serviços, após o referido aviso,
        considerada como concordância do Usuário com tais preços.
      </Typography>
      <Typography>
        Ao acessar os Serviços, por qualquer forma ou meio, ou clicar “Sign In”
        ou “Aceite” ou “Registrar-se” ou “Logar” ou “Entrar” ou “Entre com sua
        conta”, o Usuário concorda, consente e adere ao presente Termo de Uso e
        nossa Política de Privacidade disponíveis, que são portanto aderidos em
        caráter irrevogável e irretratável e obriga não somente as partes, mas
        também seus sucessores e cessionários, a qualquer título.
      </Typography>
      <br />

      <Topic text="16. Lei aplicável e possíveis demandas judiciais" />

      <Typography>
        Caso tenhamos algum problema, fica eleito o foro da cidade de Goiânia,
        Estado de Goiás, para resolver qualquer demanda oriunda do presente
        Termo de Uso e/ou Política de Privacidade. O presente Termo de Uso e a
        Política de Privacidade e todos os aspectos da relação jurídica por eles
        instituídas serão regidos e interpretados pelas leis da República
        Federativa do Brasil.
      </Typography>
      <Typography>
        A XMEI se reserva o direito de assumir ou fiscalizar a defesa e o
        controle exclusivo de qualquer caso/procedimento (“Demanda”) que
        eventualmente possa sujeitar a XMEI a indenização a que o Usuário tenha
        dado causa, não isentando-se de suas obrigações indenizatórias,
        concordando o Usuário que não realizará qualquer acordo no contexto de
        eventual Demanda, judicial ou não, sem o prévio consentimento da XMEI
      </Typography>
      <Typography className={classes.textMarginTop10}>
        O Usuário, desde já, concorda em cooperar plenamente com a XMEI, quando
        da solicitação desta, em qualquer demanda, judicial ou não, em que a
        XMEI possa ser responsabilizada ou, de qualquer forma, prejudicada.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        Se em algum momento, qualquer disposição (ou parte de qualquer
        disposição) destes Termos de Uso é, ou tornar-se ilegal, inválida ou
        inexequível em qualquer aspecto, sob a lei de qualquer jurisdição, isto
        não afetará ou prejudicará a legalidade, validade ou execução nessa ou
        em qualquer outra jurisdição de qualquer outra disposição (ou qualquer
        outra parte da mesma disposição) destes Termos de Uso.
      </Typography>
      <br />

      <Topic text="17. Dúvidas ou sugestões?" />

      <Typography className={classes.text}>
        Caso o Usuário ainda tenha alguma dúvida ou não entendeu alguma coisa
        sobre nossos Serviços, a XEMEI solicita a gentileza do Usuário em
        contactá-la através do e-mail contato@xmeibrasil.com.br
      </Typography>
      <Typography className={classes.textMarginTop10}>
        A XMEI fará o possível para que o USUÁRIO se sinta seguro e a vontade
        para utilizar os Serviços da XMEI. Qualquer sugestão, idéia, informações
        ou materiais não especificamente solicitados pela XMEI também são bem
        vindos. Não obstante, caso o Usuário envie sugestões, conteúdos ou
        ideias à XMEI, o Usuário desde já concorda que a XMEI poderá usar
        referidas sugestões, conteúdos ou ideias para qualquer propósito que
        seja, incluindo seu desenvolvimento ou comercialização, não sendo devido
        em tais casos pagamento algum por parte da XMEI ao Usuário.
      </Typography>
      <br />

      <Topic text="18. Compliance" />

      <Typography className={classes.text}>
        A XMEI assume que seus agentes, funcionários e subcontratados deverão
        cumprir durante a sua vigência todas as leis anticorrupção. A XMEI
        garante que não irá, em razão do presente instrumento, ou de quaisquer
        outras transações comerciais envolvendo qualquer das Partes, transferir
        qualquer coisa de valor, direta ou indiretamente, a qualquer pessoa do
        setor privado ou funcionários do governo ou de empresas controladas pelo
        governo, a fim de obter ou manter qualquer outro benefício ou vantagem
        indevida. A XMEI garante que nenhum dinheiro pago ao mesmo será
        utilizado a título de compensação ou de outra forma será usado para
        pagar qualquer suborno ou propina em violação da lei aplicável. A XMEI
        manterá uma contabilidade precisa e atualizada de todos os negócios que
        envolvem este instrumento. A XMEI concorda em responder prontamente às
        dúvidas relacionadas com o programa anticorrupção e outros controles
        relacionados ao disposto nesta Cláusula e que cooperará plenamente em
        qualquer investigação de uma violação de suas disposições.
      </Typography>
      <div>
        <br />
        <div style={{ flex: 2 }}>
          <Typography className={classes.textStyle}>
            CONTRATO DE SERVI&Ccedil;OS ESPECIAIS DE ASSESSORIA LEGAL
          </Typography>
        </div>
        <Typography className={classes.text}>
          Pelo presente instrumento particular, as partes doravante denominadas,
          CONTRATADA e CONTRATANTE, na melhor forma de direito, ajustam e
          contratam a presta&ccedil;&atilde;o de servi&ccedil;os profissionais,
          segundo as cl&aacute;usulas e condi&ccedil;&otilde;es adiante
          arroladas.
        </Typography>
        <br />

        <Topic text="OBJETO DO CONTRATO" />

        <Typography className={classes.text}>
          O objeto do presente consiste na presta&ccedil;&atilde;o pela
          CONTRATADA &agrave; CONTRATANTE, dos seguintes servi&ccedil;os
          profissionais:
        </Typography>
        <Typography className={classes.text}>
          a) Abertura, altera&ccedil;&atilde;o contratual ou baixa de empresa.
        </Typography>
        <br />

        <Topic text="Da forma de execu&ccedil;&atilde;o dos trabalhos" />

        <Typography className={classes.text}></Typography>
        <Typography className={classes.text}>
          Os servi&ccedil;os constantes ser&atilde;o executados pela equipe de
          profissionais mediante reuni&otilde;es, contatos por meio de
          comunica&ccedil;&atilde;o digital (portal web ou APP) e
          apresenta&ccedil;&atilde;o do relat&oacute;rio e/ou do processo
          conclusivo das atividades acima contratadas.
        </Typography>
        <br />

        <Topic text="DA CONFIDENCIALIDADE" />

        <Typography className={classes.text}>
          A CONTRATADA se obriga a manter o mais absoluto sigilo com
          rela&ccedil;&atilde;o a toda e qualquer informa&ccedil;&atilde;o
          confidencial, conforme defini&ccedil;&atilde;o abaixo, obtida em
          raz&atilde;o do presente Contrato de Presta&ccedil;&atilde;o de
          Servi&ccedil;os.
        </Typography>
        <br />

        <Topic text="DOS HONOR&Aacute;RIOS" />

        <Typography className={classes.text}>
          Os honor&aacute;rios foram calculados com base nas horas
          t&eacute;cnicas previstas para execu&ccedil;&atilde;o dos mesmos.
        </Typography>
        <Typography className={classes.text}>
          N&atilde;o est&atilde;o contemplados em nossos honor&aacute;rios os
          valores de taxas devidos pelos &oacute;rg&atilde;os oficiais (Junta
          Comercial, Receita Federal, Prefeitura e Corpo de Bombeiros).
        </Typography>
        <br />

        <Topic text="DA VIG&Ecirc;NCIA" />

        <Typography className={classes.text}>
          Par&aacute;grafo primeiro - O presente contrato ter&aacute;
          vig&ecirc;ncia a partir da sua assinatura at&eacute; a
          conclus&atilde;o dos trabalhos.
        </Typography>
        <br />

        <Topic text="DA RESCIS&Atilde;O CONTRATUAL" />

        <Typography className={classes.text}>
          &Eacute; admitido o cancelamento dos servi&ccedil;os em at&eacute; 7
          dias da contrata&ccedil;&atilde;o. Nestes casos ser&atilde;o
          devolvidos integralmente o valor pago. Outrossim, ap&oacute;s este
          prazo n&atilde;o h&aacute; previs&atilde;o de cancelamento e
          devolu&ccedil;&atilde;o dos honor&aacute;rios.
        </Typography>
        <Typography className={classes.text}></Typography>
        <br />

        <Topic text="DOS DEVERES DA CONTRATADA" />

        <Typography className={classes.text}>
          A CONTRATADA desempenhar&aacute; os servi&ccedil;os enumerados na
          cl&aacute;usula primeira com todo zelo, dilig&ecirc;ncia e
          honestidade, observada a legisla&ccedil;&atilde;o vigente,
          resguardando os interesses da CONTRATANTE, sem preju&iacute;zo da
          dignidade e independ&ecirc;ncia profissionais.
        </Typography>
        <Typography className={classes.text}>
          A CONTRATADA ser&aacute; respons&aacute;vel por todos os documentos a
          ela entregues pela CONTRATANTE, enquanto permanecerem sob sua guarda
          para a consecu&ccedil;&atilde;o dos servi&ccedil;os pactuados,
          respondendo pelo seu mau uso, perda, extravio ou
          inutiliza&ccedil;&atilde;o, salvo comprovado caso fortuito ou
          for&ccedil;a maior, mesmo se tal ocorrer por a&ccedil;&atilde;o ou
          omiss&atilde;o de seus prepostos ou quaisquer pessoas que a eles
          tenham acesso.
        </Typography>
        <Typography className={classes.text}>
          A CONTRATADA n&atilde;o assume nenhuma responsabilidade pelas
          conseq&uuml;&ecirc;ncias de informa&ccedil;&otilde;es,
          declara&ccedil;&otilde;es ou documenta&ccedil;&atilde;o
          inid&ocirc;neas ou incompletas que lhe forem apresentadas, bem como
          por omiss&otilde;es pr&oacute;prias da CONTRATANTE ou decorrentes do
          desrespeito &agrave; orienta&ccedil;&atilde;o prestada.
        </Typography>
        <br />

        <Topic text="DOS DEVERES DA CONTRATANTE" />

        <Typography className={classes.text}>
          Obriga-se a CONTRATANTE a fornecer &agrave; CONTRATADA todos os dados,
          documentos e informa&ccedil;&otilde;es que se fa&ccedil;am
          necess&aacute;rios ao bom desempenho dos servi&ccedil;os ora
          contratados, em tempo h&aacute;bil, nenhuma responsabilidade cabendo
          &agrave; segunda acaso recebidos intempestivamente.
        </Typography>
        <br />

        <Topic text="DO FORO" />

        <Typography className={classes.text}>
          Fica eleito o Foro da Cidade de Goi&acirc;nia com expressa renuncia a
          qualquer outro, por mais privilegiado que seja, para dirimir as
          quest&otilde;es oriundas da interpreta&ccedil;&atilde;o e
          execu&ccedil;&atilde;o do presente contrato.
        </Typography>
      </div>
      <div>
        <br />
        <div style={{ flex: 2 }}>
          <Typography className={classes.textStyle}>
            CONTRATO DE ASSINATURA DE SERVI&Ccedil;O RECORRENTE
          </Typography>
        </div>
        <br />
        <div>
          <Typography className={classes.text}>
            Pelo presente instrumento particular, as partes doravante
            denominadas, CONTRATADA e CONTRATANTE, na melhor forma de direito,
            ajustam e contratam a presta&ccedil;&atilde;o de servi&ccedil;os
            profissionais, segundo as cl&aacute;usulas e condi&ccedil;&otilde;es
            adiante arroladas.
          </Typography>
          <br />

          <Topic text="OBJETO DO CONTRATO" />
          <Typography className={classes.text}>
            O objeto do presente consiste na presta&ccedil;&atilde;o pela
            CONTRATADA &agrave; CONTRATANTE, dos seguintes servi&ccedil;os
            profissionais:
          </Typography>
          <Typography className={classes.text}>
            1) Disponibiliza&ccedil;&atilde;o do acesso ao APP denominado
            &ldquo;Imobitech GO&rdquo;;
          </Typography>
          <Typography className={classes.text}>
            2) Assessoria fiscal permanente;
          </Typography>
          <Typography className={classes.text}>
            3) C&aacute;lculo e disponibiliza&ccedil;&atilde;o das guias de
            impostos no aplicativo;
          </Typography>
          <Typography className={classes.text}>
            4) Disponibiliza&ccedil;&atilde;o de solu&ccedil;&atilde;o para
            emiss&atilde;o de nota fiscal no aplicativo (mediante a
            contrata&ccedil;&atilde;o pela contratada do certificado digital),
            exceto para munic&iacute;pios sem integra&ccedil;&atilde;o com nossa
            plataforma de emiss&atilde;o e-notas.
          </Typography>
          <Typography className={classes.text}>
            5) Disponibiliza&ccedil;&atilde;o das certid&otilde;es negativas
            para acompanhamento e monitoramento da empresa;
          </Typography>
          <Typography className={classes.text}>
            6) Elabora&ccedil;&atilde;o e cumprimento das
            obriga&ccedil;&otilde;es acess&oacute;rias Federais e Municipais.
          </Typography>
          <br />

          <Topic text="Da forma de execu&ccedil;&atilde;o dos trabalhos" />
          <Typography className={classes.text}>
            Os servi&ccedil;os ser&atilde;o executados por meio do aplicativo
            Imobitech GO, atendimento via whatsapp ou mesmo
            liga&ccedil;&atilde;o telef&ocirc;nica ou e-mail.
          </Typography>
          <br />

          <Topic text="DA CONFIDENCIALIDADE" />
          <Typography className={classes.text}>
            A CONTRATADA se obriga a manter o mais absoluto sigilo com
            rela&ccedil;&atilde;o a toda e qualquer informa&ccedil;&atilde;o
            confidencial, conforme defini&ccedil;&atilde;o abaixo, obtida em
            raz&atilde;o do presente Contrato de Presta&ccedil;&atilde;o de
            Servi&ccedil;os.
          </Typography>
          <br />

          <Topic text="DOS HONOR&Aacute;RIOS" />
          <Typography className={classes.text}>
            Os honor&aacute;rios dos servi&ccedil;os &eacute; de{' '}
            <strong>R$ 99,90 (noventa e nove reais e noventa centavos) </strong>
            venc&iacute;vel na data de assinatura deste aplicativo, sendo
            debitado automaticamente no cart&atilde;o de cr&eacute;dito
            cadastrado.{' '}
            <strong>
              Os honor&aacute;rios sofrer&atilde;o reajuste a cada 12 meses a
              contar da data da assinatura com base na varia&ccedil;&atilde;o do
              IPCA
            </strong>{' '}
            deste per&iacute;odo.
          </Typography>
          <Typography className={classes.text}>
            Os honor&aacute;rios s&atilde;o devidos mesmo que a empresa
            n&atilde;o tenha movimento, visto as obriga&ccedil;&otilde;es
            acess&oacute;rias que devem ser cumpridas pela equipe, independente
            da empresa ter movimento.{' '}
          </Typography>
          <br />

          <Topic text="DA VIG&Ecirc;NCIA" />
          <Typography className={classes.text}>
            O presente contrato ter&aacute; vig&ecirc;ncia a partir da sua
            assinatura (modelo de assinatura com pagamento e vig&ecirc;ncia
            mensal). A falta de pagamento da assinatura implicar&aacute; na
            suspens&atilde;o imediata da execu&ccedil;&atilde;o dos
            servi&ccedil;os ora pactuados, bem como considerar rescindido o
            presente, independentemente de notifica&ccedil;&atilde;o judicial ou
            extrajudicial.
          </Typography>
          <Typography className={classes.text}>
            A partir do cancelamento da assinatura dos servi&ccedil;os a
            CONTRATADA n&atilde;o ter&aacute; mais responsabilidade de cumprir
            com qualquer uma das obriga&ccedil;&otilde;es acess&oacute;rias,
            sendo importante destacar que a aus&ecirc;ncia destas
            obriga&ccedil;&otilde;es incorrer&aacute; em penalidades (multas)
            por parte das autoridades fiscais.
          </Typography>
          <br />

          <Topic text="DOS DEVERES DA CONTRATADA" />
          <Typography className={classes.text}>
            Par&aacute;grafo primeiro - A CONTRATADA desempenhar&aacute; os
            servi&ccedil;os enumerados na cl&aacute;usula primeira com todo
            zelo, dilig&ecirc;ncia e honestidade, observada a
            legisla&ccedil;&atilde;o vigente, resguardando os interesses da
            CONTRATANTE, sem preju&iacute;zo da dignidade e independ&ecirc;ncia
            profissional.
          </Typography>
          <Typography className={classes.text}>
            A CONTRATADA n&atilde;o assume nenhuma responsabilidade pelas
            conseq&uuml;&ecirc;ncias de informa&ccedil;&otilde;es,
            declara&ccedil;&otilde;es ou documenta&ccedil;&atilde;o
            inid&ocirc;neas ou incompletas que lhe forem apresentadas, bem como
            por omiss&otilde;es pr&oacute;prias da CONTRATANTE ou decorrentes do
            desrespeito &agrave; orienta&ccedil;&atilde;o prestada.
          </Typography>
          <br />

          <Topic text="DOS DEVERES DA CONTRATANTE" />
          <Typography className={classes.text}>
            Obriga-se a CONTRATANTE a fornecer &agrave; CONTRATADA todos os
            dados, documentos e informa&ccedil;&otilde;es que se fa&ccedil;am
            necess&aacute;rios ao bom desempenho dos servi&ccedil;os ora
            contratados, em tempo h&aacute;bil, nenhuma responsabilidade cabendo
            &agrave; segunda acaso recebidos intempestivamente.
          </Typography>
          <Typography className={classes.text}>
            Efetuar o pagamento dos honor&aacute;rios fixados neste contrato nos
            valores e datas estipulados, sendo a cobran&ccedil;a atrav&eacute;s
            de cart&atilde;o de cr&eacute;dito.
          </Typography>
          <Typography className={classes.text}></Typography>
          <br />

          <Topic text="DO FORO" />
          <Typography className={classes.text}>
            Fica eleito o Foro da Cidade de Goi&acirc;nia com expressa renuncia
            a qualquer outro, por mais privilegiado que seja, para dirimir as
            quest&otilde;es oriundas da interpreta&ccedil;&atilde;o e
            execu&ccedil;&atilde;o do presente contrato.{' '}
          </Typography>
          <Typography className={classes.text}></Typography>
        </div>
      </div>
    </div>
  );
}

export default ModalWithTermsOfService;
